/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Details from '~/components/Details';
import {
  getStatusImageAndLabel,
  ProcessStatus,
} from '~/components/Details/getStatus';
import InstanceDetails from '~/components/Details/InstanceDetails';
import MainInstanceDetails from '~/components/Details/MainInstanceDetails';
import TabsContainer, { ITab } from '~/components/TabsContainer';
import { IState } from '~/store';
import {
  getExecutionListBySolicitationRequest,
  getProcessInstanceRequest,
} from '~/store/modules/processes/actions';

import listFixedDetails from './fixedDetails';

interface RequestDetailsProps {
  processInstanceId?: string;
  open: boolean;
  modalState: (opened: boolean) => void;
}

const RequestDetails: React.FC<RequestDetailsProps> = ({
  processInstanceId,
  open,
  modalState,
}) => {
  const [tab, setTab] = useState<number>(0);

  const processInstance = useSelector(
    (state: IState) => state.processes.solicitationInstance,
  );
  const loading = useSelector(
    (state: IState) => state.processes.loadingSolicitation,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (open && processInstanceId)
      dispatch(getProcessInstanceRequest(processInstanceId, 'solicitation'));

    return () => setTab(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const requestTabs: ITab[] = [
    {
      label: 'Solicitação',
      value: 0,
      content: (
        <MainInstanceDetails
          process={processInstance}
          loading={loading}
          fixedDetails={listFixedDetails(processInstance)}
        />
      ),
    },
    {
      label: 'Execuções',
      value: 1,
      content: (
        <InstanceDetails
          getfixedDetails={listFixedDetails}
          instanceList={{
            find: () => {
              if (processInstanceId)
                dispatch(
                  getExecutionListBySolicitationRequest(processInstanceId),
                );
            },
            pathToEntity: 'processes',
            pathToInstance: 'executionList',
            pathToLoading: 'loadingExecutionsBySolicitation',
          }}
          instanceDetails={{
            find: (execution) =>
              dispatch(getProcessInstanceRequest(execution.id, 'execution')),
            pathToEntity: 'processes',
            pathToInstance: 'executionInstance',
            pathToLoading: 'loadingExecution',
          }}
          statusProps={{
            statuses: [
              ProcessStatus.IN_PROGRESS,
              ProcessStatus.COMPLETED,
              ProcessStatus.EXTERNALLY_TERMINATED,
              ProcessStatus.INTERNALLY_TERMINATED,
            ],
            getStatus: getStatusImageAndLabel,
          }}
        />
      ),
    },
  ];

  return (
    <Details
      loading={loading}
      title={processInstance?.nomeSolicitacao}
      open={open}
      modalState={modalState}
    >
      <TabsContainer
        ariaLabel="request_tabs"
        value={tab}
        onChange={setTab}
        options={requestTabs}
      />
    </Details>
  );
};

export default RequestDetails;
